// PURPLE AND GREEN

import React, { useState } from "react";
import CustomModal from "components/Modal/CustomModal";
import Axios from "API/Axios";
import { AxiosMethodEnum } from "API/Axios";
import { Axios_Route } from "API/AxiosRouts";
import { notify, ToastType } from "utils/Toast";
import { ValidationErrorMessages } from "utils/Error";

interface Props {
  TableContent: any;
  HeaderMinWidth?: Array<any>;
  changeData: () => void;
}

const ContactRequest: React.FC<Props> = ({
  TableContent,
  HeaderMinWidth,
  changeData,
}) => {
  const [showModalComment, setShowModalComment] = useState<boolean>(false);
  const [modalContentComment, setModalContentComment] = useState<string>("");
  const [showModalCommentDelete, setShowModalCommentDelete] =
    useState<boolean>(false);
  const [deleteIdComment, setDeleteIdComment] = useState<number | undefined>();

  const showComment = (content: string) => {
    setShowModalComment(true);
    setModalContentComment(content);
  };

  const deleteCommentVerify = (id: number) => {
    setShowModalCommentDelete(true);
    setDeleteIdComment(id);
  };

  const deleteRequestFunc = (id: number | undefined) => {
    if (typeof id === undefined) {
      notify(ValidationErrorMessages.ERRORS.TRY_AGAIN, ToastType.error);
    } else {
      Axios(
        AxiosMethodEnum.post,
        Axios_Route.CONTACT_AGENT_REQUEST_DELETE + `?messageId=${id}`
      ).then(({ response, success }) => {
        if (success) {
          changeData();
          setShowModalCommentDelete(false);
          setDeleteIdComment(undefined);
          notify(
            ValidationErrorMessages.SUCCESS.REQUEST_DELETED_SUCCESSFULLY,
            ToastType.success
          );
        } else {
          notify(ValidationErrorMessages.ERRORS.TRY_AGAIN, ToastType.error);
        }
      });
    }
  };

  return (
    <>
      {TableContent.map((item: any, key: any) => (
        <div
          key={key}
          style={{
            borderBottom:
              key === TableContent.length - 1 ? "none" : "1px solid #f6f6f6",
          }}
          className="table-content"
        >
          <p
            style={{
              minWidth: HeaderMinWidth !== undefined ? HeaderMinWidth[0] : "",
            }}
          >
            {item.depostId !== null && item.depostId !== undefined ? (
              <a
                style={{ backgroundColor: "#fff", color: "blue" }}
                href={`https://home.delta.ir/Search/DepoistDetails/${item.depostId}`}
                target={"_blank"}
              >
                {item.depostId}
              </a>
            ) : (
              item.messageId
            )}
          </p>
          <p
            style={{
              minWidth: HeaderMinWidth !== undefined ? HeaderMinWidth[1] : "",
            }}
          >
            {item.date}
          </p>
          <p
            style={{
              minWidth: HeaderMinWidth !== undefined ? HeaderMinWidth[2] : "",
            }}
          >
            {item.fullName}
          </p>
          <p
            style={{
              minWidth: HeaderMinWidth !== undefined ? HeaderMinWidth[3] : "",
            }}
          >
            {item.phone}
          </p>
          <p
            style={{
              minWidth: HeaderMinWidth !== undefined ? HeaderMinWidth[4] : "",
            }}
          >
            {item.emailAddress}
          </p>
          <p
            style={{
              minWidth: HeaderMinWidth !== undefined ? HeaderMinWidth[5] : "",
            }}
          >
            <span
              onClick={() => showComment(item.context)}
              className="show-data-btn"
            >
              Show Comment
            </span>
            <span
              onClick={() => deleteCommentVerify(item.messageId)}
              className="delete-btn"
            >
              Delete
            </span>
          </p>
        </div>
      ))}
      <CustomModal
        showModal={showModalComment}
        close={() => setShowModalComment(false)}
        closeAble={true}
        maxWidth={"90%"}
      >
        <div>
          <p
            style={{
              borderBottom: "solid 1px",
              fontWeight: "600",
              marginBottom: "20px",
            }}
          >
            Comment
          </p>
          <p style={{ fontSize: "14px" }}>{modalContentComment}</p>
        </div>
      </CustomModal>
      <CustomModal
        showModal={showModalCommentDelete}
        close={() => setShowModalCommentDelete(false)}
        closeAble={true}
        maxWidth={"90%"}
      >
        <div>
          <p
            style={{
              borderBottom: "solid 1px",
              fontWeight: "600",
              marginBottom: "20px",
            }}
          >
            Delete
          </p>
          <p style={{ fontSize: "14px" }}>
            Are your sure you want to delete this comment?
          </p>
          <p style={{ fontSize: "14px", marginTop: "10px" }}>
            Comment code:{" "}
            <span style={{ fontWeight: "800" }}>{deleteIdComment}</span>
          </p>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "end",
              marginTop: "30px",
            }}
          >
            <span
              onClick={() => deleteRequestFunc(deleteIdComment)}
              className="delete-btn verify-delete"
            >
              Delete Comment
            </span>
            <span
              onClick={() => setShowModalCommentDelete(false)}
              className="cancel-btn"
            >
              Cancel
            </span>
          </div>
        </div>
      </CustomModal>
    </>
  );
};

export default ContactRequest;
